module.exports = __webpack_public_path__ + "static/media/computer.cb01edec.png";